$(document).ready(function () {
	
	var urlFront = window.location.href;
	var isProductsPage = urlFront.includes("/products/t-n-original-mattress");

	if (isProductsPage) {
		var shopButton = $(".tn_button");

		if (shopButton) shopButton[0].innerHTML = "Learn More";
		shopButton[1].innerHTML = "Learn More";

		$(shopButton[0]).click(function (e) {
			e.preventDefault();
			$("html, body").animate(
				{
					scrollTop: $("#comfTitle").offset().top,
				},
				2000
			);
		});

		$(shopButton[1]).click(function (e) {
			e.preventDefault();
			$("html, body").animate(
				{
					scrollTop: $("#comfTitle").offset().top,
				},
				2000
			);
		});
	}

	function updateBvSummaryPosition() {
		var $content = $("[data-bv-summary-custom-container]");
		if (window.matchMedia("(min-width: 768px)").matches) {
			if (
				!$content
					.parent()[0]
					.hasAttribute("data-bv-summary-desktop-placeholder")
			) {
				var $desktopPlaceholder = $("[data-bv-summary-desktop-placeholder]");
				$content.appendTo($desktopPlaceholder);
			}
		} else {
			if (
				!$content.parent()[0].hasAttribute("data-bv-summary-mobile-placeholder")
			) {
				var $mobilePlaceholder = $("[data-bv-summary-mobile-placeholder]");
				$content.appendTo($mobilePlaceholder);
			}
		}
	}
	$(window).resize(updateBvSummaryPosition);
	updateBvSummaryPosition();
});
